module.exports = __webpack_public_path__ + "img/xl_2.ba8fe3bf.png";